import { Mail, Instagram, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return (
    <div className="container-x py-16 lg:py-24" data-testid="contact-page">
      <div className="max-w-2xl">
        <div className="font-script text-2xl text-[#D97757]">say hello</div>
        <h1 className="font-serif text-5xl lg:text-6xl mt-2 leading-tight">We'd love to hear from you.</h1>
        <p className="mt-6 text-[#5C4D43] leading-relaxed">
          Questions about an order, a custom request, or just want to share a photo of your little
          friend at home? Reach us anywhere below — we usually reply within a day.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-6">
        <a href="mailto:info@teddystinyfriends.co.uk" data-testid="contact-email" className="card-soft p-6 hover:-translate-y-1 transition-all">
          <Mail className="text-[#D97757]" />
          <div className="font-serif text-xl mt-4">Email</div>
          <div className="text-sm text-[#5C4D43] mt-1 underline">info@teddystinyfriends.co.uk</div>
        </a>
        <a href="https://www.instagram.com/teddystinyfriendsuk/" target="_blank" rel="noreferrer" data-testid="contact-instagram" className="card-soft p-6 hover:-translate-y-1 transition-all">
          <Instagram className="text-[#D97757]" />
          <div className="font-serif text-xl mt-4">Instagram</div>
          <div className="text-sm text-[#5C4D43] mt-1 underline">@teddystinyfriendsuk</div>
        </a>
        <Link to="/personalise" data-testid="contact-custom" className="card-soft p-6 hover:-translate-y-1 transition-all">
          <MessageCircle className="text-[#D97757]" />
          <div className="font-serif text-xl mt-4">Personalisation</div>
          <div className="text-sm text-[#5C4D43] mt-1">Animal, colour, name, birthday — tell us</div>
        </Link>
      </div>

      <div className="mt-16 p-10 rounded-3xl bg-[#F4EFE6]">
        <h2 className="font-serif text-3xl">FAQ</h2>
        <div className="mt-6 space-y-6">
          {[
            ["How long does an order take?", "Because each friend is crocheted just for you after you order, timing depends on current demand. We currently aim for 1-3 weeks from order to dispatch and will always let you know where yours is in the queue."],
            ["Are they safe for children?", "Yes — our toys are made to comply with the UK Toys (Safety) Regulations 2011 and the relevant BS EN 71 standards (mechanical, flammability and chemical). Plastic safety eyes are fitted with a locking washer and pull-tested. Toys with safety eyes carry the standard \"Not suitable for children under 36 months\" warning and adult supervision is always recommended. See our full Safety statement for details."],
            ["Are they flammable?", "Like virtually all plush toys, ours are filled with hi-loft polyester fibrefill — a synthetic textile that is flammable. They are tested to meet BS EN 71-2 (the UK toy flammability standard), but each toy ships with the legally-required \"Keep away from fire — contains flammable materials\" warning label. Please keep your little friend well away from candles, open fires, hobs, heaters and other naked flames."],
            ["Can I add a name and birthday?", "Absolutely. The personalization is part of what makes each friend special. Add it on the product page."],
            ["Where do you deliver?", "We currently deliver within the UK only, via Royal Mail 2nd class. Delivery time depends on Royal Mail and order volume — quieter weeks are quick, busy weeks take a little longer."],
            ["Why is everything so new?", "Because we just opened! Teddys Tiny Friends is a brand-new family-run shop. Your order will be one of our very first — thank you for trusting us."],
          ].map(([q, a]) => (
            <div key={q}>
              <div className="font-medium text-[#2C211B]">{q}</div>
              <div className="text-[#5C4D43] mt-1">{a}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
